import {
  browserLocalPersistence,
  inMemoryPersistence,
  type Persistence,
} from "firebase/auth";

const CANONICAL_STAGING_PROJECT_ID = "tu-conferences-stg-2026";
const CANONICAL_STAGING_ORIGIN = "https://tu-conferences-stg-2026.web.app";

export interface FirebaseAuthRuntimeBoundary {
  readonly projectId: string;
  readonly origin: string;
}

export type FirebaseAuthPersistenceMode = "memory" | "local";

export function isCanonicalStagingCertificationRuntime({
  projectId,
  origin,
}: FirebaseAuthRuntimeBoundary): boolean {
  return (
    projectId === CANONICAL_STAGING_PROJECT_ID &&
    origin === CANONICAL_STAGING_ORIGIN
  );
}

export function selectFirebaseAuthPersistence(
  boundary: FirebaseAuthRuntimeBoundary,
): Persistence {
  return selectFirebaseAuthPersistenceMode(boundary) === "memory"
    ? inMemoryPersistence
    : browserLocalPersistence;
}

export function selectFirebaseAuthPersistenceMode(
  boundary: FirebaseAuthRuntimeBoundary,
): FirebaseAuthPersistenceMode {
  return isCanonicalStagingCertificationRuntime(boundary) ? "memory" : "local";
}
